import { Layout, Typography, Space } from "antd";
import { GithubOutlined, LinkedinOutlined, MailOutlined, WhatsAppOutlined } from "@ant-design/icons";
import { sendGAEvent } from "../../utils";

const { Footer } = Layout;
const { Text, Link } = Typography;

const AppFooter = () => (
  <Footer
    style={{
      background: "#fafafa",
      borderTop: "1px solid #eaeaea",
      textAlign: "center",
      padding: "24px 16px",
      marginTop: 40,
    }}
  >
    <Space direction="vertical" size="middle" style={{ width: "100%" }}>
      {/* Título e descrição */}
      <Space direction="vertical" size="small">
        <Text strong style={{ fontSize: 16 }}>
          Terraformando &copy; {new Date().getFullYear()}
        </Text>
        <Text type="secondary" style={{ fontSize: 14 }}>
          Construindo nuvens com código
        </Text>
      </Space>

      {/* Informações de contato direto */}
      <Space direction="vertical" size="small">
        <Text strong style={{ fontSize: 14, color: '#595959' }}>
          Contato
        </Text>
        <Space size="large" wrap>
          <Link
            href="mailto:silvano.amaral9@gmail.com"
            onClick={() => sendGAEvent("contact_click", { type: "email" })}
            style={{ display: 'flex', alignItems: 'center', gap: 6 }}
          >
            <MailOutlined style={{ fontSize: 16 }} />
            <span>silvano.amaral9@gmail.com</span>
          </Link>
          <Link
            href="https://wa.me/5511944487679"
            target="_blank"
            onClick={() => sendGAEvent("contact_click", { type: "whatsapp" })}
            style={{ display: 'flex', alignItems: 'center', gap: 6 }}
          >
            <WhatsAppOutlined style={{ fontSize: 16 }} />
            <span>11 - 94448-7679</span>
          </Link>
        </Space>
      </Space>

      {/* Redes sociais */}
      <Space direction="vertical" size="small">
        <Text strong style={{ fontSize: 14, color: '#595959' }}>
          Conecte-se
        </Text>
        <Space size="large">
          <Link
            href="https://github.com/silvanoamaral"
            target="_blank"
            onClick={() => sendGAEvent("social_click", { network: "github" })}
            data-ga-event="social_click"
            data-ga-label="github"
            style={{ display: 'flex', alignItems: 'center', gap: 6 }}
          >
            <GithubOutlined style={{ fontSize: 18 }} />
            <span>GitHub</span>
          </Link>
          <Link
            href="https://www.linkedin.com/in/silvano-amaral/"
            target="_blank"
            aria-label="LinkedIn"
            onClick={() => sendGAEvent("social_click", { network: "linkedin" })}
            data-ga-event="social_click"
            data-ga-label="linkedin"
            style={{ display: 'flex', alignItems: 'center', gap: 6 }}
          >
            <LinkedinOutlined style={{ fontSize: 18 }} />
            <span>LinkedIn</span>
          </Link>
        </Space>
      </Space>

      {/* Assinatura */}
      <Text type="secondary" style={{ fontSize: 12, marginTop: 8 }}>
        Feito com <span role="img" aria-label="coração">❤️</span> por entusiastas de Cloud & DevOps
      </Text>
    </Space>
  </Footer>
);

export default AppFooter;